let idCounter = 0;

export const generateUniqueId = (base: string): string => {
	idCounter++;
	return `${base}-${idCounter}`;
};
